import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import {
  setAuthUser,
  setAuthentication,
  setGuestLogin,
} from '../../redux/features/Authentication/Customer/authUserSlice';
import {
  clearCheckoutAdjustmentDraft,
  getCheckoutSessionScope,
} from '../../utils/checkoutAdjustmentDraft';
import { flushChatbotOnLogout } from '../../utils/flushChatbotOnLogout';

const SESSION_TIMEOUT_MS = 2 * 60 * 60 * 1000;
const LOGOUT_CHECK_INTERVAL_MS = 1000;

const LogoutTimer = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state) => state.authUser?.isAuthenticated,
  );
  const userData = useSelector((state) => state.authUser?.UserData);
  const isGuest = useSelector((state) => state.authUser?.isGuest);
  const logoutAtRef = useRef(Date.now() + SESSION_TIMEOUT_MS);
  const localUserData = Cookies.get('userLoginData');
  const sessionScope = getCheckoutSessionScope({
    userData,
    isAuthenticated,
    isGuest,
  });
  const previousSessionScopeRef = useRef(sessionScope);

  useEffect(() => {
    if (previousSessionScopeRef.current !== sessionScope) {
      clearCheckoutAdjustmentDraft();
      previousSessionScopeRef.current = sessionScope;
    }
  }, [sessionScope]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'userLoginData' || event.key === 'is_guest') {
        clearCheckoutAdjustmentDraft();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    const handleUserActivity = () => {
      logoutAtRef.current = Date.now() + SESSION_TIMEOUT_MS;
    };

    const checkLogoutTime = () => {
      if (Date.now() <= logoutAtRef.current) return;

      logoutAtRef.current = Number.POSITIVE_INFINITY;
      localStorage.removeItem('userLoginData');
      Cookies.remove('userLoginData');
      Cookies.remove('is_guest');
      flushChatbotOnLogout(dispatch);
      localStorage.clear();
      dispatch(setAuthUser([]));
      dispatch(setAuthentication(false));
      dispatch(setGuestLogin(''));
      window.location.href = '/';
    };

    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keypress', handleUserActivity);
    window.addEventListener('click', handleUserActivity);
    const timerId = window.setInterval(
      checkLogoutTime,
      LOGOUT_CHECK_INTERVAL_MS,
    );

    return () => {
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keypress', handleUserActivity);
      window.removeEventListener('click', handleUserActivity);
      window.clearInterval(timerId);
    };
  }, [dispatch]);

  useEffect(() => {
    if (localUserData || !isAuthenticated) return;

    logoutAtRef.current = Number.POSITIVE_INFINITY;
    localStorage.removeItem('userLoginData');
    Cookies.remove('userLoginData');
    Cookies.remove('is_guest');
    flushChatbotOnLogout(dispatch);
    localStorage.clear();
    dispatch(setAuthUser([]));
    dispatch(setAuthentication(false));
    dispatch(setGuestLogin(''));
    window.location.href = '/';
  }, [dispatch, isAuthenticated, localUserData]);

  return null;
};

export default LogoutTimer;
